export const contactServices = [
  'Shipping',
  'Packing',
  'Printing',
  'Mailbox Rental',
  'Notary',
  'Document Services',
  'Digital Marketing & Business Services',
  'Other',
] as const

export type ContactService = (typeof contactServices)[number]
